import type { V2GuidedSystemBuilderSchema as GuidedSystemBuilderSchema } from '@ecomm/shared-components'
import classNames from 'classnames'
import { useState } from 'react'

import { useHideUntilMounted } from '@ecomm/shared-hooks'
import { CartLink } from './CartLink'
import { NavLink } from './NavLink'
import { NavMenu } from './NavMenu'
import { type CourtesyNavItemType, cartItem } from './data'
import type { HeaderRedesignSchema } from './schema'

type CourtesyNavProps = HeaderRedesignSchema & {
  readonly items: readonly CourtesyNavItemType[]
  readonly cartQuantity: number
  readonly quoteWizard: GuidedSystemBuilderSchema
}

/**
 * TODO: remove this after `All | US | Nav | Monitoring and Phone` is done.
 *
 * Account and cart icons are not part of this experiment so we don't want to hide them.
 */
function shouldAddClasses(name: string, classes: string): string {
  return ['Account', 'Cart'].includes(name) ? '' : classes
}

export function CourtesyNav({
  items,
  images,
  cartQuantity,
  quoteWizard
}: CourtesyNavProps) {
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(-1)

  /**
   * TODO: remove this after `All | US | Nav | Monitoring and Phone` is done.
   */
  const classes = useHideUntilMounted('CourtesyNav')

  return (
    <div
      className={`flex h-full items-center gap-6 text-white min-[1126px]:ml-auto min-[1126px]:gap-9}`}
    >
      {items.map((item, i) => {
        return item.hasDropdown ? (
          <div
            className={`hidden min-[1126px]:block ${shouldAddClasses(item.text, classes)}`}
            key={`${item.text}-1`}
          >
            <NavMenu
              displayInSideNav={item.displayInSideNav}
              dropdownMenu={item.dropdownMenu}
              icon={item.icon}
              images={images}
              onToggleDropdown={(close?: boolean) =>
                setActiveDropdownIndex(
                  close ? -1 : activeDropdownIndex === i ? -1 : i
                )
              }
              quoteWizard={quoteWizard}
              showDropdown={activeDropdownIndex === i}
              showOverlay={false}
              text={item.text}
            />
          </div>
        ) : (
          <div
            className={classNames(shouldAddClasses(item.text, classes), {
              '[&:not(:last-of-type)]:mr-2':
                items.filter(item => !item.hasDropdown).length > 1,
              'min-[1126px]:hidden': item.mobileOnly,
              'hidden min-[1126px]:grid':
                !item.mobileOnly && item.displayInSideNav
            })}
            key={`${item.text}-2`}
          >
            {item.url === cartItem.url ? (
              <CartLink
                cartQuantity={cartQuantity}
                icon={item.icon}
                text={item.text}
                url={item.url}
              />
            ) : (
              <NavLink
                icon={item.icon}
                mobileOnly={item.mobileOnly}
                openQuiz={item.openQuiz}
                quoteWizard={quoteWizard}
                text={item.text}
                url={item.url}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
